export async function parseVAK(): Promise<Map<number, string>> {
  try {
    const data = await (await fetch('https://rego-cdn.miprorego.io/yklista.html')).text();

    const tableEl = document.createElement('table');
    tableEl.innerHTML = data;


    const output = new Map();
    tableEl.querySelectorAll('tr').forEach(
      (lineElement: HTMLElement) => {
        const rows = lineElement.querySelectorAll('td');
        if (rows.length >= 2) {
          const link = rows[1].innerHTML;
          const i = link.indexOf('"') + 1;
          if (i) {
            output.set(parseInt(rows[0].innerText), 'https://www.ttl.fi/ova/' + link.substring(i, link.indexOf('"', i + 2)));
          }
        }
      });

    console.log(output);
    return output;
  } catch (e) {
    return new Map();
  }
}
